import { Table, Thead, Tbody, Tr, Th, Tooltip } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import { ProjectRecordListItem } from './ProjectRecordListItem';
import type { ProjectRecordDto } from '~/common/api/zeiterfassungServerApi/ProjectRecordApi';
import React from 'react';

interface Props {
  records: ProjectRecordDto[];
  onMarkSeen: (id: number) => void;
  markingId?: number;
  getEmployeeName?: (employeeId: number) => string | undefined;
}

export const ProjectRecordsList: React.FC<Props> = ({
  records,
  onMarkSeen,
  markingId,
  getEmployeeName,
}) => {
  const t = useTranslate();
  return (
    <Table size="sm">
      <Thead>
        <Tr>
          <Th>{t('projectRecords.column.project')}</Th>
          <Th>{t('projectRecords.column.employee')}</Th>
          <Th>{t('projectRecords.column.start')}</Th>
          <Th>{t('projectRecords.column.duration')}</Th>
          <Th>{t('projectRecords.column.comment')}</Th>
          <Th>
            <Tooltip label="dauer / Project.calculated_project_time" hasArrow>
              {t('projectRecords.column.factorCalculated')}
            </Tooltip>
          </Th>
          <Th>
            <Tooltip
              label="dauer / Σ(job.duration × job.done_per_project)"
              hasArrow
            >
              {t('projectRecords.column.factorAggregated')}
            </Tooltip>
          </Th>
          <Th>{t('projectRecords.column.seen')}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {records.map((r) => (
          <ProjectRecordListItem
            key={r.id}
            record={r}
            onMarkSeen={onMarkSeen}
            isMarking={markingId === r.id}
            employeeName={getEmployeeName?.(r.employee?.id)}
          />
        ))}
      </Tbody>
    </Table>
  );
};
